// extracted by mini-css-extract-plugin
export default {"voice-tag":"VoiceTag_voice-tag__iRfPn","waveform":"VoiceTag_waveform__W8uEf","audio-button":"VoiceTag_audio-button__kNGd-"};